import { FC, ReactElement } from 'react';
import { Box } from '@chakra-ui/react';
import RecognitionStar from 'ui/components/Icons/RecognitionStar';
import styles from './CustomRecognitionStar.module.css';
export interface CustomRecognitionStarProps {
  icon: ReactElement;
  iconColor: string;
  id?: string;
  width?: number;
  height?: number;
}
export const CustomRecognitionStar: FC<CustomRecognitionStarProps> = ({
  icon,
  iconColor,
  id,
  width = 16,
  height = 16
}) => {
  return <>
      <Box id={id ? `custom_star_${id}` : undefined} className={styles.starContainer} data-sentry-element="Box" data-sentry-source-file="CustomRecognitionStar.tsx">
        <RecognitionStar width={width} height={height} color={iconColor} data-sentry-element="RecognitionStar" data-sentry-source-file="CustomRecognitionStar.tsx" />
        <Box height={height} width={width} className={styles.iconContainer} data-sentry-element="Box" data-sentry-source-file="CustomRecognitionStar.tsx">
          {icon}
        </Box>
      </Box>
    </>;
};